// src/api/file/playbackPositionApi.ts
import { ENV } from '../../config/runtimeEnv';
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_FILE_SERVER;

export const getPlaybackPosition = async (patientId: UserUuid, fileId: string): Promise<{ position: number; last_played_at?: string }> => {
	try {
		const response = await http.post(
			`${API_BASE_URL}/playback-positions/get`,
			{
				patient_id: patientId,
				file_id: fileId,
			}
		);
		return response.data;
	} catch (error) {
		throw new Error(`Error fetching playback position: ${error}`);
	}
};

export const updatePlaybackPosition = async (patientId: UserUuid, fileId: string, position: number): Promise<void> => {
	try {
		await http.post(
			`${API_BASE_URL}/playback-positions/update`,
			{
				patient_id: patientId,
				file_id: fileId,
				position,
			}
		);
	} catch (error) {
		throw new Error(`Error updating playback position: ${error}`);
	}
};

export const resetPlaybackPosition = async (patientId: UserUuid, fileId: string): Promise<void> => {
	try {
		await http.post(
			`${API_BASE_URL}/playback-positions/reset`,
			{
				patient_id: patientId,
				file_id: fileId,
			}
		);
	} catch (error) {
		throw new Error(`Error resetting playback position: ${error}`);
	}
};